import { useLocation } from "react-router-dom";
import { Phone, Send } from "lucide-react";
import { trackPhoneClick, trackEvent } from "../lib/tracking";

const PHONE_DISPLAY = "02 38 74 50 60";
const PHONE_TEL = "0238745060";

/**
 * Sticky bottom CTA bar — visible on mobile only (lg:hidden).
 * Two buttons: direct phone call + jump to contact form.
 * Hidden in admin/tenant areas to avoid interfering with workflow UIs.
 */
export const StickyMobileCTA = () => {
  const { pathname } = useLocation();
  // Hide on admin / tenant / reservation / auth pages
  if (
    pathname.startsWith("/admin") ||
    pathname.startsWith("/locataire") ||
    pathname.startsWith("/reserver") ||
    pathname.startsWith("/paiement")
  ) {
    return null;
  }

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t-2 border-slate-900 shadow-[0_-4px_12px_rgba(0,0,0,0.15)]"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={`tel:${PHONE_TEL}`}
        onClick={() => trackPhoneClick(PHONE_DISPLAY)}
        className="flex items-center justify-center gap-2 py-3 bg-slate-900 text-white font-bold uppercase tracking-wider text-sm active:bg-slate-800"
        data-testid="sticky-mobile-call"
      >
        <Phone className="w-4 h-4" strokeWidth={2.5} />
        Appeler
      </a>
      <a
        href="/contact"
        onClick={() => trackEvent("cta_click", { cta: "sticky_mobile_contact", page: pathname })}
        className="flex items-center justify-center gap-2 py-3 bg-[#FFC107] text-slate-900 font-bold uppercase tracking-wider text-sm active:bg-yellow-400"
        data-testid="sticky-mobile-contact"
      >
        <Send className="w-4 h-4" strokeWidth={2.5} />
        Visiter
      </a>
    </div>
  );
};

export default StickyMobileCTA;
